module.exports = __webpack_public_path__ + "img/newimg12.2a2cc221.jpg";